function About() {
  return (
    <div >
      <h1 id="role-heading1">About TechQuest</h1>
<div className="aboutpara"> 
      <p>
        At <span className="font-semibold">TechQuest</span>, we believe learning tech shouldn’t be locked behind paywalls. 
        That’s why we’ve built a <span className="font-semibold">free, beginner-friendly platform</span> packed with 
        handpicked resources, step-by-step roadmaps, and clear learning paths for popular tech roles.
      </p>

      <p >
        Whether you’re a student or an aspiring tech enthusiast, TechQuest guides you from 
        <span className="font-semibold"> where you are</span> to 
        <span className="font-semibold"> where you want to be</span> — with no confusion, no cost, and no limits.
      </p>

      <p>
        Plus, boost your career readiness with our <span className="font-semibold">professional resume builder</span>, 
        featuring multiple sleek templates to help you stand out.
      </p>

      <p>Features Provided By TechQuest :</p>
      <ul>
        <li>Role-Based Tech Roadmaps</li>
        <li>Curated Learning Resources</li>
        <li>Level-Based Learning Structure</li>
        <li>Progress Tracking System</li>
        <li>Free Resume Builder Tool</li>
        <li>Personal Search Engine (PSE)</li>
        <li>Guest Login Option </li>
        <li>Feedback & Suggestions System</li>
      </ul>

      <h3>
        Start exploring, learn at your own pace, and take your first confident step into tech — 
        with <span className="font-bold">TechQuest</span> by your side.
      </h3>

      </div>
    </div>
  );
}

export default About;
